export const formatFrenchNarrativeStyle = (value?: string | null): string => {
  const raw = (value || '').trim()
  if (!raw) return ''
  const normalized = raw
    .toLowerCase()
    .replace(/[^a-z]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

  if (!normalized) return raw

  const hasModern = normalized.includes('modern') || normalized.includes('accessible')
  const hasClassical = normalized.includes('classical') || normalized.includes('literary')
  const hasPresent = normalized.includes('present')

  if (hasPresent) {
    if (hasModern) {
      return 'Modern/Accessible Past Tense with Present Tense'
    }
    if (hasClassical) {
      return 'Classical/Literary Past Tense with Present Tense'
    }
    return 'Present Tense'
  }

  if (hasModern) {
    return 'Modern/Accessible Past Tense'
  }

  if (hasClassical) {
    return 'Classical/Literary Past Tense'
  }

  if (normalized === 'present') {
    return 'Present Tense'
  }

  return raw
}
